import { AccordionSummary, AccordionSummaryProps } from '@material-ui/core'
import React from 'react'
import YumSwitch from '../YumSwitch/YumSwitch'
import { createStyles, Theme, withStyles } from '@material-ui/core/styles'

interface YumSwitchAccordionSummaryProps extends AccordionSummaryProps {
  expanded: boolean
}

const YumSwitchAccordionSummary = withStyles((theme: Theme) =>
  createStyles({
    expandIcon: {
      transform: 'none !important', // Prevent rotation
      transition: 'none !important', // Disable the animation transition
    },
  }),
)(({ expanded, ...props }: YumSwitchAccordionSummaryProps) => {
  return <AccordionSummary expandIcon={<YumSwitch checked={expanded} noMargin={true} />} {...props} />
})

export default YumSwitchAccordionSummary
